<template>
  <div>
    <HomeVideo />
    <vs-row
      vs-align="center"
      vs-type="flex"
      vs-justify="center"
      vs-w="8"
      class="text-center mx-auto mt-6 mb-3"
    >
      <h1 class="text-center my-3">About Us</h1>
      <div class="text-center my-3 text-2xl">
        Ballstar is democratizing data for the amateur athlete. Our scorekeeping
        software is designed to eliminate pen and paper from the game. We are on
        a mission to organize the world's sports information, with a current
        focus on <span class="text-primary">basketball</span>.
      </div>
    </vs-row>
    <vs-divider />
    <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
      <vs-col
        vs-align="center"
        vs-type="flex"
        vs-justify="flex-end"
        vs-w="6"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-row vs-w="12" vs-sm="12" vs-xs="12">
          <img
            width="100%"
            src="https://f001.backblazeb2.com/file/ballstar/EveryPlayerCounts-Large.png"
            alt="Every Player Counts"
            class="mx-auto"
          />
        </vs-row>
      </vs-col>
      <vs-col
        vs-align="center"
        vs-type="flex"
        vs-justify="flex-start"
        vs-w="6"
        vs-sm="12"
        vs-xs="12"
      >
        <div class="mx-6"><EveryPlayerCountsVideo /></div>
      </vs-col>
    </vs-row>
    <vs-row
      vs-align="center"
      vs-type="flex"
      vs-justify="center"
      vs-w="8"
      class="text-center mx-auto mt-6 mb-3"
    >
      <div class="text-center my-3 text-2xl">
        Ballstar is the easiest way for basketball leagues to keep rosters up to
        date, create matchups, engage with fans, track game stats, and generate
        analytics.
      </div>
      <div class="text-center my-3 text-2xl text-primary">
        All In the Palm of Your Hands.
      </div>
    </vs-row>
  </div>
</template>
<script>
import HomeVideo from "@/components/home-video/HomeVideo";
import EveryPlayerCountsVideo from "@/components/every-player-counts-video/EveryPlayerCountsVideo";
export default {
  name: "Home",
  components: {
    HomeVideo,
    EveryPlayerCountsVideo
  },
  metaInfo() {
    return { title: this.$route.meta.title };
  }
};
</script>
